import Error from './Error'
import { connect } from 'react-redux'

const mapStateToProps = state => ({
  locale: state.router.locale,
})

export default connect(
  mapStateToProps,
)(Error)
